import React from "react";
import styled, { keyframes, css, useTheme } from "styled-components";
import { color, shadow, space } from "styled-system";

const Style = styled.a`
  width: inherit;
  height: auto;
  text-decoration: none;
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;
  overflow: hidden;
  animation-fill-mode: forwards;
  ${color};
  ${shadow};
  ${space};
  animation: ${({ animation, animationLength }) =>
    animation &&
    animationLength &&
    css`
      ${animation} ${animationLength} ${({ theme }) => theme.cubicBezier}
    `};
  animation-delay: ${({ animationDelay }) =>
    animationDelay &&
    css`
      ${animationDelay}
    `};
  animation-fill-mode: forwards;
`;

const Child = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

export const Link = (props) => {
  const { children, ...other } = props;

  return (
    <Style type="link" {...other} target="_blank" rel="noopener noreferrer">
      <Child>{children}</Child>
    </Style>
  );
};
